import React from "react";
import Grid from "@mui/joy/Grid";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import AspectRatio from "@mui/joy/AspectRatio";
import Button from "@mui/joy/Button";
import HikingIcon from "@mui/icons-material/Hiking";
import Divider from "@mui/material/Divider";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import Looks4Icon from "@mui/icons-material/Looks4";
import LandscapeIcon from "@mui/icons-material/Landscape";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HandshakeIcon from "@mui/icons-material/Handshake";
import "../css/landing.css";
import { useNavigate } from "react-router-dom";

export default function Landing() {
  let navigate = useNavigate();
  let url = process.env.REACT_APP_FRONTEND_URL;
  let logo = url + "/uploads/logo.svg";

  let primeraSeccion = () => {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fffaeb",
            paddingTop: { xs: "3rem", lg: 0 },
            marginBottom: { xs: "10rem", lg: 0 },
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              paddingLeft: "10%",
              paddingRight: "10%",
              alignItems: "center",
            }}
          >
            <Grid
              xs={12}
              lg={6}
              sx={{
                display: "flex-grid",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              <AspectRatio
                variant="plain"
                ratio="1"
                sx={{
                  width: "100px",
                  marginBottom: "2rem",
                  borderRadius: "12px",
                }}
              >
                <img src={logo} alt="logo" style={{ objectFit: "contain" }} />
              </AspectRatio>
              <Typography level="h1" sx={{ marginBottom: "1rem" }}>
                ¿Buscas Compañeros de Aventuras? 🏔️
              </Typography>
              <Typography level="body-sm">
                Encuentra personas para hacer trekking, montañismo, trail
                running y más.
              </Typography>
              <Button
                size="md"
                sx={{
                  marginTop: "1rem",
                  backgroundColor: "#123524",
                  color: "white",
                  borderColor: "#123524",
                  "&:hover": {
                    backgroundColor: "#0f2d1e", // Un tono ligeramente más oscuro en hover
                    borderColor: "#0f2d1e",
                  },
                  marginBottom: { xs: "2rem", lg: 0 },
                }}
                endDecorator={<HikingIcon />}
                onClick={() => {
                  navigate("/registro");
                }}
              >
                Unete ahora
              </Button>
            </Grid>
            <Grid
              xs={12}
              lg={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <AspectRatio ratio="0.8" sx={{ width: 500, borderRadius: 6 }}>
                <img src={url + "/uploads/landing1.jpg"} alt="" srcset="" />
              </AspectRatio>
            </Grid>
          </Grid>
          <Box>
            <Divider />
          </Box>
        </Box>
      </div>
    );
  };

  let segundaSeccion = () => {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fffaeb",
            marginBottom: { xs: "5rem", lg: 0 },
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              paddingLeft: "10%",
              paddingRight: "10%",
              alignItems: "center",
            }}
          >
            <Grid
              xs={12}
              lg={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <AspectRatio ratio="0.8" sx={{ width: 500, borderRadius: 6 }}>
                <img src={url + "/uploads/landing2.jpg"} alt="" srcset="" />
              </AspectRatio>
            </Grid>
            <Grid
              xs={12}
              lg={6}
              sx={{
                display: "flex-grid",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Typography level="h1" sx={{ marginBottom: "1rem" }}>
                No vuelvas a explorar solo 🤝
              </Typography>

              <Typography level="body-sm">
                Amigoutdoors es una Webapp creada para conectar aventureros. Si
                te apasiona el aire libre pero te cuesta encontrar con quién
                salir, aquí puedes conocer compañeros con tus mismos intereses,
                organizar aventuras y vivir experiencias inolvidables.
              </Typography>

              <Button
                size="md"
                sx={{
                  marginTop: "1rem",
                  backgroundColor: "#123524",
                  color: "white",
                  borderColor: "#123524",
                  "&:hover": {
                    backgroundColor: "#0f2d1e", // Un tono ligeramente más oscuro en hover
                    borderColor: "#0f2d1e",
                  },
                }}
                onClick={() => {
                  navigate("/registro");
                }}
              >
                Registrate Gratis
              </Button>
            </Grid>
          </Grid>
          <Box>
            <Divider />
          </Box>
        </Box>
      </div>
    );
  };

  let terceraSeccion = () => {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fffaeb",
            marginBottom: { xs: "5rem", lg: 0 },
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              paddingLeft: "10%",
              paddingRight: "10%",
              alignItems: "center",
            }}
          >
            <Grid
              xs={12}
              lg={6}
              sx={{
                display: "flex-grid",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Typography
                level="h1"
                sx={{ marginBottom: "1rem", textAlign: "center" }}
              >
                ¿Cómo funciona?
              </Typography>

              <Grid container spacing={2}>
                <Box
                  sx={{
                    width: "100%",
                    marginBottom: "1rem",
                    marginTop: "1rem",
                  }}
                >
                  <Card>
                    <CardContent>
                      <Typography
                        variant="h5"
                        startDecorator={<LooksOneIcon />}
                      >
                        Regístrate Gratis
                      </Typography>
                      <Typography>
                        {" "}
                        Crea tu perfil en segundos y accede a la comunidad.{" "}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
                <Box sx={{ width: "100%", marginBottom: "1rem" }}>
                  <Card>
                    <CardContent>
                      <Typography
                        variant="h5"
                        startDecorator={<LooksTwoIcon />}
                      >
                        Descubre Aventuras
                      </Typography>
                      <Typography>
                        {" "}
                        Encuentra salidas creadas por otros o publica la tuya.{" "}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
                <Box sx={{ width: "100%", marginBottom: "1rem" }}>
                  <Card>
                    <CardContent>
                      <Typography variant="h5" startDecorator={<Looks3Icon />}>
                        Conéctate
                      </Typography>
                      <Typography>
                        {" "}
                        Da like, haz match y chatea con otros aventureros.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
                <Box sx={{ width: "100%", marginBottom: "1rem" }}>
                  <Card>
                    <CardContent>
                      <Typography variant="h5" startDecorator={<Looks4Icon />}>
                        Explora
                      </Typography>
                      <Typography>
                        Vive experiencias inolvidables y sigue explorando.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: "1rem",
                }}
              >
                <Button
                  size="md"
                  variant="solid"
                  color="neutral"
                  sx={{
                    marginTop: "1rem",
                    backgroundColor: "#123524",
                    color: "white",
                    borderColor: "#123524",
                    "&:hover": {
                      backgroundColor: "#0f2d1e", // Un tono ligeramente más oscuro en hover
                      borderColor: "#0f2d1e",
                    },
                  }}
                  onClick={() => {
                    navigate("/registro");
                  }}
                  endDecorator={<LandscapeIcon />}
                >
                  Únete a una nueva aventura
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Box>
            <Divider />
          </Box>
        </Box>
      </div>
    );
  };

  let cuartaSeccion = () => {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fffaeb",
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              paddingLeft: "10%",
              paddingRight: "10%",
              alignItems: "center",
            }}
          >
            <Grid
              xs={12}
              lg={6}
              sx={{
                display: "flex-grid",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Typography level="h1" sx={{ marginBottom: "1rem" }}>
                Beneficios de unirte
              </Typography>
              <List>
                <ListItem>
                  <ListItemDecorator>
                    <CheckCircleIcon color="success" />
                  </ListItemDecorator>
                  Conecta con aventureros como tú.
                </ListItem>
                <ListItem>
                  <ListItemDecorator>
                    <CheckCircleIcon color="success" />
                  </ListItemDecorator>
                  Descubre rutas y experiencias nuevas.
                </ListItem>
                <ListItem>
                  <ListItemDecorator>
                    <CheckCircleIcon color="success" />
                  </ListItemDecorator>
                  Encuentra compañeros para tus salidas.
                </ListItem>
                <ListItem>
                  <ListItemDecorator>
                    <CheckCircleIcon color="success" />
                  </ListItemDecorator>
                  Crea y comparte tus propias aventuras.
                </ListItem>
              </List>
              <Button
                size="md"
                sx={{
                  marginTop: "1rem",
                  backgroundColor: "#123524",
                  color: "white",
                  borderColor: "#123524",
                  "&:hover": {
                    backgroundColor: "#0f2d1e", // Un tono ligeramente más oscuro en hover
                    borderColor: "#0f2d1e",
                  },
                }}
                onClick={() => {
                  navigate("/registro");
                }}
                endDecorator={<HandshakeIcon />}
              >
                Encuentra a tu próximo compañero
              </Button>
            </Grid>
            <Grid
              xs={12}
              lg={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <AspectRatio
                ratio="0.8"
                sx={{
                  width: 500,
                  borderRadius: 6,
                  marginTop: { xs: "1rem", lg: 0 },
                }}
              >
                <img src={url + "/uploads/landing3.jpg"} alt="" srcset="" />
              </AspectRatio>
            </Grid>
          </Grid>
          <Box>
            <Divider />
          </Box>
        </Box>
      </div>
    );
  };

  let quintaSeccion = () => {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fffaeb",
          }}
        >
          <Card
            className="footerlanding"
            sx={{
              width: "80%",
              height: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              backgroundImage: `url(${url}/uploads/landing4.jpg)`,
            }}
          >
            <Typography sx={{ color: "white" }} level={"h1"}>
              Experiencias inolvidables te esperan
            </Typography>
            <Typography sx={{ color: "white" }} level="h4">
              Únete ahora y empieza a explorar junto a nuevos amigos
            </Typography>
            <Button
              size="md"
              sx={{
                marginTop: "1rem",
                backgroundColor: "#EFE3C2",
                color: "black",
                borderColor: "#EFE3C2",
                "&:hover": {
                  backgroundColor: "#EFE3C2", // Un tono ligeramente más oscuro en hover
                  borderColor: "#EFE3C2",
                },
              }}
              onClick={() => {
                navigate("/registro");
              }}
            >
              Registrate Gratis
            </Button>{" "}
          </Card>
        </Box>
      </div>
    );
  };

  return (
    <div>
      <Box sx={{ backgroundColor: "#fffaeb" }}>
        {primeraSeccion()}
        {segundaSeccion()}
        {terceraSeccion()}
        {cuartaSeccion()}
        {quintaSeccion()}
      </Box>
    </div>
  );
}
